import { takeLastItem } from "../arrayUtils";

export const takeArgumentN = n => (...args) => args[n];

export const takeFirstArgument = takeArgumentN(0);

export const takeLastArgument = (...args) => takeLastItem(args);

export const takeArgumentProp = propName => (obj = {}) =>
    obj ? obj[propName] : undefined;

export const callWithNtsArgument = (argIndex, fn) => (...args) =>
    fn(args[argIndex]);
